import React, { useEffect, useState } from "react";
import cn from "classnames";
import { useLocation } from "react-router-dom";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import arrow from "@src/assets/svg/arrow.svg";
import { GatewaysListRow } from "@src/components/molecules/gateways-list-row/gateways-list-row";
import styles from "./gateways-list-body.module.scss";
import { GatewayWithMachinesViewStateTypes } from "@src/types/gateways-with-machines";

const cssClassName = "gateways-list-body";

interface GatewaysListBodyProps {
  data: GatewayWithMachinesViewStateTypes[];
  description: string;
}

export const GatewaysListBody = ({
  data = [],
  description,
}: GatewaysListBodyProps) => {
  const location = useLocation();
  const [isGridVisible, setIsGridVisible] = useState(true);
  const targetGatewayUuid =
    new URLSearchParams(location.search).get("gateway_uuid")?.trim() || "";

  useEffect(() => {
    if (targetGatewayUuid && !isGridVisible) {
      setIsGridVisible(true);
    }
  }, [targetGatewayUuid, isGridVisible]);

  const toggleGridVisibility = () => {
    setIsGridVisible(!isGridVisible);
  };

  const rows = [
    <tr key="description">
      <td className={styles[`${cssClassName}__description-container`]}>
        <span className={styles[`${cssClassName}__description-text`]}>
          {description}
        </span>
        <span
          className={cn(
            styles[`${cssClassName}__description-text`],
            styles[`${cssClassName}__description-text--gray`],
          )}
        >
          {data.length}
        </span>
        <IconButton
          icon={arrow}
          fun={toggleGridVisibility}
          rotate={isGridVisible}
        />
      </td>
    </tr>,
  ];

  if (isGridVisible && data) {
    rows.push(
      ...data.map((gatewayData, i) => (
        <GatewaysListRow
          key={gatewayData.gateway_uuid || i}
          gatewayData={gatewayData}
        />
      )),
    );
  }

  return rows;
};
